import { render, staticRenderFns } from "./SedesLayout.vue?vue&type=template&id=c4fa3d1a&scoped=true"
import script from "./SedesLayout.vue?vue&type=script&lang=js"
export * from "./SedesLayout.vue?vue&type=script&lang=js"
import style0 from "./SedesLayout.vue?vue&type=style&index=0&id=c4fa3d1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4fa3d1a",
  null
  
)

export default component.exports